import { formatBytes } from "@lib/numbers";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@ui/alert-dialog";
import { useImportStore } from "@upload/importStore";
import { acceptSizeWarning, cancelImport } from "@upload/upload";
import { useShallow } from "zustand/react/shallow";

export function FastaSizeWarningDialog() {
  const warnedImports = useImportStore(
    useShallow((state) =>
      state.imports.filter((item) => item.status === "sizeWarning"),
    ),
  );

  const current = warnedImports[0];
  if (!current) return null;

  function handleContinue() {
    if (!current) return;
    acceptSizeWarning(current.id);
  }

  function handleCancel() {
    if (!current) return;
    cancelImport(current.id);
  }

  return (
    <AlertDialog open>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Large FASTA file</AlertDialogTitle>
          <AlertDialogDescription>
            <strong>{current.fileName}</strong> is{" "}
            {formatBytes(current.decompressedSize ?? 0)} decompressed. Importing
            it will take a while and use significant browser storage.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleContinue}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
